var PrecedenceLevels;
(function (PrecedenceLevels) {
  PrecedenceLevels["PRIMARY"] = "PRIMARY";
  PrecedenceLevels["SECONDARY"] = "SECONDARY";
})(PrecedenceLevels || (PrecedenceLevels = {}));
export default PrecedenceLevels;